export class ClinicalTrial {
    constructor(
       public clinicalTrailId:number,
       public  patientId: number,
       public visitId: number,
       public  physicianId: number,
       public  locationId: number,
       public  enroldate: string,
       public  trailStartDate: string,
       public  trailStopDate: string,
       public  trailDiscontinuedate: string,
       public  reasonforDiscontinue: string,
       public trailProtocal:string ,
       public sponser:string ,
       public enteredBy: string,
       public  enteredDate: string
    ){}
}
